import http from "./http";

export default {
  getCarriers() {
    return http.get("/carriers");
  },
  syncFromShipStation() {
    return http.post("/carriers/sync");
  }
};
